// Message locations and their configuration for default communication channels
export const MESSAGE_LOCATIONS = [
  {
    key: 'dailyRosterStandupAnnouncements',
    label: 'Daily Roster: Standup Announcements',
    allowsDeviceSms: true,
    allowsEmail: true,
    allowsInApp: true
  },
  {
    key: 'dailyRosterRosterAssignments', 
    label: 'Daily Roster: Roster Assignments',
    allowsDeviceSms: true,
    allowsEmail: true,
    allowsInApp: true
  },
  {
    key: 'dailyRosterVehiclePhotoLogLinks',
    label: 'Daily Roster: Vehicle Photo Log Links', 
    allowsDeviceSms: true,
    allowsEmail: true,
    allowsInApp: true
  },
  {
    key: 'dailyRosterIncompleteChecklistLinks',
    label: 'Daily Roster: Incomplete Checklist Links',
    allowsDeviceSms: true, 
    allowsEmail: true,
    allowsInApp: true
  },
  {
    key: 'dailyRosterCustomMessages',
    label: 'Daily Roster: Custom Messages',
    allowsDeviceSms: true,
    allowsEmail: false, // Disabled per HERA-7289 requirements
    allowsInApp: true
  },
  {
    key: 'associateListCustomMessages',
    label: 'Associate List: Custom Messages', 
    allowsDeviceSms: false,
    allowsEmail: false, // Disabled per HERA-7289 requirements
    allowsInApp: true
  },
  {
    key: 'automatedCoachingManualMessages',
    label: 'Automated Coaching: Manual Messages',
    allowsDeviceSms: false,
    allowsEmail: true,
    allowsInApp: true
  },
  {
    key: 'heraMessengerNewMessages',
    label: 'Hera Messenger: New Messages',
    allowsDeviceSms: false, 
    allowsEmail: false, // Disabled per HERA-7289 requirements
    allowsInApp: true
  },
  {
    key: 'automatedRecurringMessages',
    label: 'Automated Recurring Messages',
    allowsDeviceSms: false,
    allowsEmail: true,
    allowsInApp: true
  }
];

// Communication channel options
export const CHANNEL_OPTIONS = [
  {
    value: 'in_app',
    label: 'In-app to the Associate\'s Hera App'
  },
  {
    value: 'sms_personal',
    label: 'SMS to Associate\'s personal phone'
  },
  {
    value: 'sms_device', 
    label: 'SMS to assigned company Device'
  },
  {
    value: 'email',
    label: 'Email to Associate\'s email'
  }
];

// Default channel values (mock data)
export const DEFAULT_CHANNEL_VALUES = {
  dailyRosterStandupAnnouncements: 'sms_personal',
  dailyRosterRosterAssignments: 'sms_personal', 
  dailyRosterVehiclePhotoLogLinks: 'sms_personal',
  dailyRosterIncompleteChecklistLinks: 'sms_personal',
  dailyRosterCustomMessages: 'sms_personal',
  associateListCustomMessages: 'sms_personal',
  automatedCoachingManualMessages: 'sms_personal',
  heraMessengerNewMessages: 'sms_personal',
  automatedRecurringMessages: 'sms_personal'
};